import {fetchApi} from "@mbj-front-monorepo/data-access";
import {useQuery} from "@tanstack/react-query";

export const useGetResultsSearchFormationBySearch = (idSearch:number|null)=>{
    const promise = () => fetchApi("/api/results_search_formations/{id}", { method: "get", params: { id: (idSearch||-1) + "" } });
    return useQuery<Awaited<ReturnType<typeof promise>>, Error>(["result_search_formation", { idSearch }], promise, {
        enabled: !!idSearch,
    });
}
